import React, { useState } from "react";
import { YHModal } from "@/components/YHModal";
import { usePurchaseDrDetailsModel } from "./purchaseDrDetailsModel";
import { YhBox } from "@/components/YhBox";
import { Table, Select, message } from "antd";
import { ColumnsType } from "antd/lib/table";

import useGlobalModel, { transOptions } from "@/model/globalModel";
import { ISelectOptions } from "@/types/ScmTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { ISCMPDrGoodsDetail } from "../../purchaseDrTypes";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";

export const AddTempShelfModal = () => {

	const {
		addTempShelfModal: visible,
		setAddTempShelfModal,
		editGoodsList,
		setEditGoodsList
	} = usePurchaseDrDetailsModel();

	const { warehouseList, shopAndOrg: { shopId } } = useGlobalModel(({ warehouseList, shopAndOrg }) => [warehouseList, shopAndOrg]);

	const [shelfInfo, setShelfInfo] = useState<IVRMshelfDetail | null>(null);  //记录选中的货位信息

	const onCancel = () => {
		setAddTempShelfModal(false);
		setShelfInfo(null);
	};

	//货位列表 Api
	const shelfLoadData = async (whObj: ISelectOptions) => {
		const searchParams = {
			shopId,
			warehouseId: whObj.id,
			warehouseCode: whObj.value,
			code: "临时货位",
			pageSize: 10,
			pageNum: 1,
		}
		let { retData: records } = await warehouseService.shelfAllPage(searchParams);
		// const { records, ...pg } = retData;
		if (!records || !records.length) {
			message.warning("该仓库下没有临时货位，请联系后台人员添加");
			setShelfInfo(null);
			return;
		}
		setShelfInfo(records[0]);
	}

	const onSubmit = () => {
		if (!shelfInfo) {
			message.warning("请选择仓库或者该仓库没有临时货位");
			return;
		}
		setEditGoodsList(origin => origin.map(item => {
			if (!item.shelfCode) {
				return {
					...item,
					inShelfId: shelfInfo.id,   //货位Id  
					inShelfCode: shelfInfo.code,   //货位编码  
					inWarehouseName: shelfInfo.warehouseName,   //仓库名称 
					inWarehouseCode: shelfInfo.warehouseCode,  //仓库编码
					// isShelfCode: true
				}
			};
			return item;
		}));
		onCancel();
	}

	const columns: ColumnsType<ISCMPDrGoodsDetail> = [
		{
			title: '序号',
			fixed: "left",
			width: 60,
			align: "center",
			render: (t: any, r: any, i: number) => i + 1
		}, {
			title: '商品编号',
			align: "center",
			dataIndex: 'materialCode',
		}, {
			title: '商品名称',
			align: "center",
			dataIndex: 'materialName',
		}
	];

	const rightChildren = <div >
		<span className="label-name">仓库：</span>
		<Select
			style={{ width: 260 }}
			options={transOptions(warehouseList)}  //过滤掉直发库
			placeholder="请选择仓库"
			onChange={(value: string, option) => {
				value && shelfLoadData(option as ISelectOptions)
			}}
		/>
	</div>



	return <YHModal
		visible={visible}
		onOk={onSubmit}
		onCancel={onCancel}
		title="添加临时货位"
		width={'70%'}
		bodyHeight={500}
		showFooter={true}
	>
		<YhBox title={rightChildren} style={{ marginBottom: "15px" }}>
			<Table
				bordered
				columns={columns}
				dataSource={editGoodsList.filter(item => !!!item.shelfCode)}
				pagination={false}
				scroll={{ x: 'max-content', y: 400 }}
			/>
		</YhBox>
	</YHModal>
}